module.exports = __webpack_public_path__ + "static/media/no_image.fe8b8cd8.jpg";